import { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { fetchCustomizationProfile } from '../libs/dashboard';

// Module-level cache so multiple components share the same data without duplicate requests
const profileCache = new Map();

export function useBrandingProfile(bondId) {
    const { getToken } = useAuth();
    const [profile, setProfile] = useState(profileCache.has(bondId) ? profileCache.get(bondId) : undefined);

    useEffect(() => {
        if (!bondId) return;

        if (profileCache.has(bondId)) {
            setProfile(profileCache.get(bondId));
            return;
        }

        const token = getToken();
        if (!token) return;

        fetchCustomizationProfile(token, bondId)
            .then(data => {
                profileCache.set(bondId, data);
                setProfile(data);
            })
            .catch(() => {
                profileCache.set(bondId, null);
                setProfile(null);
            });
    }, [bondId, getToken]);

    return profile;
}
